import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';

export default () => (
  <InformationalModule
    // configs
    sectionId='universal-life-insurance-intro'
    moduleName='intro-module'
    moduleVariation='A'
    // content
    headingText={<>What is universal <WidowBlock>life insurance&#63;</WidowBlock></>}
    introContent={(
      <>
        <Typography
          align='left'
          nextElement='button'>
          Universal life insurance gives you lifelong protection and cash value you can use for anything, anytime, plus the flexibility to adjust your policy along the way as your life and needs change. It lets you choose the amount of your death benefit and how much you pay in premiums, as well as when you pay them.
        </Typography>
        <Link
          variant='buttonLinkPrimary'
          themeType='lightTheme'
          id='universal-life-insurance-product-intro-cta-fafa'
          ariaLabel='Get started with a financial advisor'
          linkUrl='/find-a-financial-advisor/'>
          Get started
        </Link>
      </>
    )}
  />
);
